// extracted by mini-css-extract-plugin
module.exports = {"md":"gift-popup_md_3lL3G","ios":"gift-popup_ios_2anIl","code":"gift-popup_code_3QmZO","contentLoader":"gift-popup_contentLoader_38Av3"};